import { Component, ChangeDetectionStrategy, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-general-logout-modal',
    imports: [TranslateModule, ButtonModule],
    templateUrl: './general-logout-modal.component.html',
    styleUrl: './general-logout-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralLogoutModalComponent {
    private dialogRef = inject(DynamicDialogRef);

    continue(): void {
        this.dialogRef.close();
    }
}
